// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36dc3bc1","585":"dea0d578"}[chunkId] + ".chunk.js";
};